import { State } from "./state";
import { storeInit } from "../../../Store";

const ps: State.PowerSupply = {
  id: "",
  v: 0,
  vcal: 0,
  voff: 0,
  i: 0,
  ical: 0,
  ioff: 0,
  iHigh: 0,
  iLow: 0,
  vHigh: 0,
  vLow: 0,
  Present: false
};

export const initial: State.Props = storeInit([{ ...ps }, { ...ps }]);

export default initial;
